import React from 'react'
import { StyledButton } from './styles'

const PrimaryButton = ({
  children,
  color,
  size,
  variant,
  className,
  ...otherProps
}) => {
  return (
    <StyledButton
      color={color || 'primary'}
      size={size || 'large'}
      variant={variant || 'contained'}
      disableElevation
      className={className}
      {...otherProps}
    >
      {children}
    </StyledButton>
  )
}

export default PrimaryButton
